import { AssistanceOptionsService } from '@common/ApiService'
import {
  FETCH_ASSISTANCE_OPTIONS,
  FETCH_DASHBOARD_ASSISTANCE_TYPE_FILTER_OPTIONS,
  FETCH_OTHER_ASSISTANCE_CATEGORIES_GRID,
} from '@actions'
import {
  UPDATE_ASSISTANCE_OPTIONS,
  UPDATE_DASHBOARD_ASSISTANCE_TYPE_FILTER_OPTIONS,
  UPDATE_CUSTOMER_OPTIONS_ADDITIONAL_INFO,
  SET_OTHER_ASSISTANCE_CATEGORIES_GRID,
} from '@mutations'

export const state = {
  customerOptions: {},
  stationOptions: {},
  onTrainOptions: {},
  dashboardAssistanceTypeFilterOptions: [],
  otherAssistanceCategoriesGrid: [],
}

export const mutations = {
  [UPDATE_ASSISTANCE_OPTIONS](state, data) {
    state.customerOptions = data.customer
    state.stationOptions = data.station
    state.onTrainOptions = data.on_train
  },

  [UPDATE_DASHBOARD_ASSISTANCE_TYPE_FILTER_OPTIONS](state, data) {
    state.dashboardAssistanceTypeFilterOptions = Array.isArray(data) ? data : []
  },

  [UPDATE_CUSTOMER_OPTIONS_ADDITIONAL_INFO](state, { category, key, newData }) {
    state.customerOptions[category].find((item) => item.key === key)[
      'additional_info'
    ] = newData
  },

  [SET_OTHER_ASSISTANCE_CATEGORIES_GRID](state, data) {
    state.otherAssistanceCategoriesGrid = data
  },
}

export const actions = {
  [FETCH_ASSISTANCE_OPTIONS]({ commit }, query = {}) {
    return AssistanceOptionsService.get(query).then((response) => {
      commit(UPDATE_ASSISTANCE_OPTIONS, response.data)
    })
  },

  [FETCH_DASHBOARD_ASSISTANCE_TYPE_FILTER_OPTIONS]({ commit }) {
    return AssistanceOptionsService.getDashboardAssistanceTypeFilterOptions().then((response) => {
      commit(UPDATE_DASHBOARD_ASSISTANCE_TYPE_FILTER_OPTIONS, response.data)
    })
  },

  [FETCH_OTHER_ASSISTANCE_CATEGORIES_GRID]({ commit }) {
    return AssistanceOptionsService.getOtherAssistanceCategoriesGrid().then(
      (response) => {
        commit(SET_OTHER_ASSISTANCE_CATEGORIES_GRID, response.data)
      }
    )
  },
}
